import client from '@src/lib/api/client'
import { UpdatePaybackStatusRes } from '@src/interface/api/response.interface'

export type ReqBody = {
	paybackNo: string
	status: string
	reason?: string
}

export const updatePaybackStatus = async ({
	paybackNo,
	status,
	reason,
}: ReqBody): Promise<UpdatePaybackStatusRes> => {
	const response = await client.put<UpdatePaybackStatusRes>(
		`/products/payback/${paybackNo}/status`,
		{
			status,
			reason,
		},
	)

	return response.data
}
